<script setup lang="ts">
import { useTranslation } from 'i18next-vue'
import dachmarkeSvg from '@/assets/images/logos/dachmarke.svg'

const { t } = useTranslation()
</script>

<template>
    <div class="space-y-2">
        <span class="heading-base block px-3 py-2">{{
            t('ui.footer.sponsors.dachmarke.label')
        }}</span>
        <div class="px-3 space-y-4">
            <img
                :src="dachmarkeSvg"
                class="h-12"
                :alt="t('ui.footer.sponsors.dachmarke.name')"
                loading="lazy"
                decoding="async"
            />
            <p class="label-xs-medium">{{ t('ui.footer.sponsors.dachmarke.description') }}</p>
        </div>
    </div>
</template>
